import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HandoverHistoryDialog } from 'src/app/interfaces/handover';

@Component({
  selector: 'app-handover-history-dialog',
  templateUrl: './handover-history-dialog.component.html',
  styleUrls: ['./handover-history-dialog.component.scss'],
  standalone: false,
})
export class HandoverHistoryDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<HandoverHistoryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: HandoverHistoryDialog
  ) {}

  closeDialog(): void {
    this.dialogRef.close(false);
  }
}
